import type { ActiveIntegrationConnection } from 'services/integration-service';

export type WhatsAppConnectionConfig = {
  appId: string;
  wabaId: string;
  phoneNumberId: string;
  accessToken: string;
  appSecret: string;
  verifyToken: string;
};

export const getWhatsAppChatUrl = (connection?: ActiveIntegrationConnection | null) => {
  if (!connection) return null;
  if (connection.connection_url) return connection.connection_url;

  const phone = connection.external_refs?.whatsapp?.display_phone_number;
  if (!phone) return null;

  const digits = phone.replace(/\D/g, '');
  return digits ? `https://wa.me/${digits}` : null;
};

export const EMPTY_WHATSAPP_CONFIG: WhatsAppConnectionConfig = {
  appId: '',
  wabaId: '',
  phoneNumberId: '',
  accessToken: '',
  appSecret: '',
  verifyToken: '',
};

export const isWhatsAppConfigComplete = (config: WhatsAppConnectionConfig) =>
  Object.values(config).every((value) => value.trim().length > 0);
